export default __webpack_public_path__ + "static/media/devices-blue.05407fae.svg";